import React, { useEffect, useRef, useState } from 'react';
import { IconCheck } from './icons';

// «Antes de seguir»: tarjetas una por una; las opciones de avance aparecen al marcar todas.
// item: [texto, regla, ejemplo, consecuencia]
export const Checklist = ({ items, done, onCheck, locked, onAsesor, titulo, sub, usted = false }) => {
  const [abierto, setAbierto] = useState({});
  const ref = useRef(null);
  const toggle = (key) => setAbierto((a) => ({ ...a, [key]: !a[key] }));
  const listos = done.filter(Boolean).length;
  const faltan = items.length - listos;
  useEffect(() => {
    const el = ref.current;
    const sc = el && el.closest('.conv-scroll');
    if (sc) sc.scrollTo({ top: sc.scrollTop + el.getBoundingClientRect().top - sc.getBoundingClientRect().top - 8, behavior: 'smooth' });
  }, []);
  return (
    <section className="chk" data-testid="checklist" ref={ref}>
      {titulo ? (
        <header className="chk-head">
          <strong data-testid="checklist-titulo">{titulo}</strong>
          {sub ? <span>{sub}</span> : null}
        </header>
      ) : null}
      <div className="chk-prog" data-testid="checklist-progreso">
        <span>{faltan ? `${usted ? 'Le' : 'Te'} faltan ${faltan}` : (usted ? '¡Listo! Ya lo tiene claro' : '¡Listo! Ya lo tienes claro')}</span>
        <i className="chk-bar"><b style={{ width: `${(listos / items.length) * 100}%` }} /></i>
      </div>
      {items.map((item, i) => {
        const ejemplo = item[2] || '';
        const consecuencia = item[3] || '';
        return (
          <div className={`chk-item ${done[i] ? 'ok' : ''}`} key={i} data-testid={`check-item-${i}`}>
            <div className="chk-txt">
              <span className="chk-t" dangerouslySetInnerHTML={{ __html: item[0] }} />
              <div className="chk-guias">
                {ejemplo ? (
                  <button type="button" className="chk-guia" onClick={() => toggle(`${i}-ej`)} data-testid={`check-ejemplo-${i}`}>
                    Ver un ejemplo
                  </button>
                ) : null}
                {consecuencia ? (
                  <button type="button" className="chk-guia" onClick={() => toggle(`${i}-cons`)} data-testid={`check-consecuencia-${i}`}>
                    ¿Y si no lo hago?
                  </button>
                ) : null}
                <button type="button" className="chk-guia asesor" onClick={() => onAsesor && onAsesor(item[0])} data-testid={`check-asesor-${i}`}>
                  Prefiero que me lo explique alguien
                </button>
              </div>
              {abierto[`${i}-ej`] && ejemplo ? (
                <p className="chk-expl" data-testid={`check-ejemplo-txt-${i}`}>{ejemplo}</p>
              ) : null}
              {abierto[`${i}-cons`] && consecuencia ? (
                <p className="chk-expl" data-testid={`check-consecuencia-txt-${i}`}>{consecuencia}</p>
              ) : null}
            </div>
            <button
              type="button"
              className="chk-btn"
              disabled={done[i] || locked}
              onClick={() => onCheck(i)}
              data-testid={`check-entendi-${i}`}
            >
              {done[i] ? <><IconCheck size={15} /> Me queda claro</> : 'Me queda claro'}
            </button>
          </div>
        );
      })}
    </section>
  );
};
